import React, { ReactElement } from 'react';

// Styles & Assets
import styles from './ButtonToolbar.module.css';

// Hooks
import { useState } from 'react';

// Components
import Modal from '../Modal/Modal';
import Icon from '../Icon/Icon';

// Receives a dialogComponent with one parameter of reactDispatcher and other optional of setting the ball filter
const ButtonToolbar: React.FC<{
    children?: React.ReactElement
    icon: ReactElement,
    label: string,
    defaultFilterActive?: boolean,
}> = ({ children, icon, label, defaultFilterActive }) => {

    const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
    const [ballFilterActive, setBallFilterActive] = useState<boolean>(defaultFilterActive || false);

    const setFilterBallActive = (isActive: boolean) =>
        setBallFilterActive(isActive);

    const Dialog = React.cloneElement(children as ReactElement<{
        modalShow: React.Dispatch<React.SetStateAction<boolean>>;
        setFilterBallActive: (isActive: boolean) => void
    }>, {
        modalShow: setShowFilterModal,
        setFilterBallActive
    });

    return (
        <>
            <button onClick={() => setShowFilterModal(true)} className={styles.buttonToolbar}>
                <p>{label}</p>
                <Icon>
                    {icon}
                    {ballFilterActive && <div className={styles.ballFilter} data-testid='ballFilter'></div>}
                </Icon>
            </button>
            <Modal show={showFilterModal} setShowModal={setShowFilterModal}>
                {Dialog}
            </Modal>
        </>
    );
};

export default ButtonToolbar;